import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { validateEmail } from '@nx-smartmonkey/shared/helpers';
import { useResetUserPassword } from '../../../hooks/user/useResetUserPassword';
import Button from '../../../react-components/Button';
import InputText from '../../../react-components/InputText';
import Text from '../../../react-components/Text';

export const RecoveryRequest = () => {
  const intl = useIntl();
  const [email, setEmail] = useState<string>(``);
  const { success: resetPasswordSuccess, run: requestRecovery } = useResetUserPassword();

  const handleRequestRecovery = () => {
    if (!isRequestFormDisabled()) {
      requestRecovery({ email });
    }
  };

  const isRequestFormDisabled = () => {
    return !validateEmail(email);
  };

  return (
    <>
      {!resetPasswordSuccess && (
        <Grid container direction="column" justifyContent="center" style={{ minHeight: `250px` }}>
          <Text intlId="auth.recovery.request.info" />

          <VSpacer />

          <Text intlId="auth.recovery.request.email" />

          <VSpacer small />

          <InputText
            id="email"
            type="email"
            placeholder={intl.formatMessage({ id: `none` })}
            fieldValue={email}
            onChange={(mail: any) => setEmail(mail)}
            size="medium"
            variant="outlined"
            onKeyDown={(ev) => {
              if (ev.keyCode === 13) {
                handleRequestRecovery();
              }
            }}
            inputProps={{
              style: {
                minHeight: `24px`,
              },
            }}
            required
            validators={[
              {
                errorMessage: (
                  <Text
                    tagName="span"
                    style={{ color: RoutalPalette.error.medium }}
                    intlId="validation.invalid_email"
                  />
                ),
                isInvalid: (text?: string) => !text || !validateEmail(text),
              },
            ]}
          />

          <VSpacer />

          <Grid container direction="row" justifyContent="center">
            <Button
              id="button_send_mail"
              buttonType="button"
              type="submit"
              size="large"
              disabled={isRequestFormDisabled()}
              onClick={handleRequestRecovery}
              intlId="auth.recovery.request.button_send_mail"
              style={{
                width: `100%`,
              }}
            />
          </Grid>
        </Grid>
      )}
      {resetPasswordSuccess && (
        <Grid item container alignItems="center" justifyContent="center" style={{ minHeight: `150px` }}>
          <Text style={{ textAlign: `center` }} variant="body-large" intlId="auth.recovery.request.email_sent_info" />
        </Grid>
      )}
    </>
  );
};
